import UnitTests               from 'scripts/defa/unit-tests/collection-unit-tests';
import UnitTest                from 'scripts/defa/unit-tests/model-unit-test';
import UnitTestCollectionView  from 'scripts/defa/unit-tests/view-unit-test-collection-view';
import UnitTestFeedbackView    from 'scripts/defa/unit-tests/view-unit-test-feedback-view';
import UnitTestFirmwareView    from 'scripts/defa/unit-tests/view-unit-test-firmware-view';
import UnitTestFlow            from 'scripts/defa/unit-tests/view-unit-test-flow';
import UnitTestNoInstallerForm from 'scripts/defa/unit-tests/view-unit-test-no-installer-form';
import UnitTestView            from 'scripts/defa/unit-tests/view-unit-test-view';
import Module                  from 'scripts/module';

const UnitTestsModule = new Module( 'UnitTestsModule', {
	collections: {
		UnitTests
	},
	models     : {
		UnitTest
	},
	views      : {
		UnitTestCollectionView,
		UnitTestFeedbackView,
		UnitTestFirmwareView,
		UnitTestFlow,
		UnitTestNoInstallerForm,
		UnitTestView
	}
} );

export default UnitTestsModule;